// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-container[data-v-0c062208] {\n  margin: 30px 0px;\n}\n.list-container[data-v-0c062208] :not(:last-of-type) {\n  margin-bottom: 14px;\n}", ""]);
// Exports
module.exports = exports;
